// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const projectInfo = {
    "name": "labportal2",
    "version": "2.25.0"
};
/* tslint:enable */



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/environments/version.ts